var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mb-[32px] lg:mb-[60px] mt-[60px] lg:mt-[120px]" },
        [
          _c(
            "h3",
            { staticClass: "text-brown-400 mb-16 lg:mb-24 font-bold text-35" },
            [_vm._v("Zoeken in onze blog:")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-row gap-32 items-center" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search"
                }
              ],
              staticClass:
                "rounded-4 bg-white focus:outline-none h-[60px] w-full md:w-[500px] px-24 mb-[16px] lg:mb-[0]",
              attrs: { type: "search", placeholder: "Geef jouw zoektermen in" },
              domProps: { value: _vm.search },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleSearch.apply(null, arguments)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.search = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "justify-center group flex-wrap px-[25px] py-[14px] flex items-center gap-8 font-semi bg-brown-400 text-white rounded-full hover:opacity-80 transition-opacity !bg-orange !text-white",
                on: { click: _vm.handleSearch }
              },
              [_vm._v("\n                zoeken\n            ")]
            )
          ]),
          _vm._v(" "),
          this.meta.total
            ? _c(
                "span",
                {
                  staticClass:
                    " text-brown-400 font-semi text-20 mt-[16px] block"
                },
                [_vm._v(_vm._s(this.meta.total) + " resultaten gevonden")]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "blog-filters flex flex-wrap gap-[8px] lg:gap-24 mb-[50px]"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "bg-white text-brown-400 font-semi text-20 px-[24px] py-[14px] rounded-full hover:bg-orange hover:text-white cursor-pointer transition-colors",
              class: { "!bg-orange !text-white": !_vm.category },
              on: {
                click: function($event) {
                  return _vm.changeCategory(null)
                }
              }
            },
            [_vm._v("\n            Alle artikels\n        ")]
          ),
          _vm._v(" "),
          _vm._l(_vm.categories, function(c) {
            return _c("div", {
              key: c.term_id,
              staticClass:
                "bg-white text-brown-400 font-semi text-20 px-[24px] py-[14px] rounded-full hover:bg-orange hover:text-white cursor-pointer transition-colors",
              class: { "!bg-orange !text-white": _vm.category === c.term_id },
              domProps: { innerHTML: _vm._s(c.name) },
              on: {
                click: function($event) {
                  return _vm.changeCategory(c.term_id)
                }
              }
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      !_vm.loading
        ? [
            _vm.articles.length !== 0
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "blog-articles grid grid-cols-1 lg:grid-cols-2 gap-[50px] mb-[50px]"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "grid md:grid-cols-2 grid-cols-1 lg:grid-cols-2 gap-[50px]"
                        },
                        _vm._l(_vm.articles.slice(0, 4), function(article) {
                          return _c("blog-card", {
                            key: article.id,
                            attrs: {
                              article: article,
                              "image-height": 249,
                              clamp: false
                            }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.articles.slice(4, 5), function(article) {
                        return _c("blog-card", {
                          key: article.id,
                          attrs: {
                            article: article,
                            "image-height": "auto",
                            clamp: false
                          }
                        })
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "grid grid-cols-1 lg:grid-cols-2 gap-[50px] mb-[50px]"
                    },
                    [
                      _vm._l(_vm.articles.slice(5, 6), function(article) {
                        return _c("blog-card", {
                          key: article.id,
                          attrs: {
                            article: article,
                            "image-height": "auto",
                            clamp: false
                          }
                        })
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "grid md:grid-cols-2 grid-cols-1 lg:grid-cols-2 gap-[50px]"
                        },
                        _vm._l(_vm.articles.slice(6, 10), function(article) {
                          return _c("blog-card", {
                            key: article.id,
                            attrs: {
                              article: article,
                              "image-height": 249,
                              clamp: false
                            }
                          })
                        }),
                        1
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "blog-pager flex flex-wrap items-center mb-75 xl:mb-150 justify-center w-full"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row gap-16 text-brown-400 text-30 font-bold"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-50 h-50 flex items-center justify-center cursor-pointer hover:text-orange",
                              class: {
                                "opacity-50 pointer-events-none": _vm.page === 1
                              },
                              attrs: { "data-pager-info": "previous" },
                              on: { click: _vm.nextPage }
                            },
                            [_c("i", { staticClass: "fas fa-chevron-left" })]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.paginatedPages, function(p) {
                            return _c(
                              "div",
                              {
                                key: p,
                                staticClass:
                                  "w-50 h-50 flex items-center justify-center cursor-pointer hover:text-orange transition-colors",
                                class: {
                                  "bg-orange !text-white": p == _vm.page
                                },
                                attrs: { "data-pager-info": p },
                                on: {
                                  click: function($event) {
                                    return _vm.changePage(p)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(p) +
                                    "\n                    "
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-50 h-50 flex items-center justify-center cursor-pointer hover:text-orange",
                              class: {
                                "opacity-50 pointer-events-none":
                                  _vm.page === parseInt(_vm.meta.pages)
                              },
                              attrs: { "data-pager-info": "next" },
                              on: { click: _vm.prevPage }
                            },
                            [_c("i", { staticClass: "fas fa-chevron-right" })]
                          )
                        ],
                        2
                      )
                    ]
                  )
                ]
              : _c(
                  "div",
                  {
                    staticClass:
                      "text-brown-400 font-semi text-20  p-[60px] lg:p-[120px] text-center"
                  },
                  [
                    _vm._v(
                      "\n            we konden geen resultaten vinden\n        "
                    )
                  ]
                )
          ]
        : _c(
            "div",
            { staticClass: "flex flex-wrap p-75 items-center justify-center" },
            [_c("loader", { staticClass: "h-50", attrs: { loading: true } })],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }